export default "__VITE_ASSET__h0O2Up_Z__"